
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/cross-departmental-communication-teamsreminder-channels",
      function () {
        return require("private-next-pages/article/cross-departmental-communication-teamsreminder-channels.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/cross-departmental-communication-teamsreminder-channels"])
      });
    }
  